import { render, staticRenderFns } from "./ipTable.vue?vue&type=template&id=28dd0221&scoped=true"
import script from "./ipTable.vue?vue&type=script&lang=js"
export * from "./ipTable.vue?vue&type=script&lang=js"
import style0 from "./ipTable.vue?vue&type=style&index=0&id=28dd0221&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dd0221",
  null
  
)

export default component.exports